import { Colors } from "@constants";
import { TestIDs } from "@utils";
import React from "react";
import { ActivityIndicator, StyleSheet, ViewStyle } from "react-native";
import { Container, Label } from "./WhiteButton.style";

interface IProps {
  forwardTestID?: string;
  label?: string;
  onPress?: () => void;
  disabled?: boolean;
  loading?: boolean;
  styleButton?: ViewStyle;
}

export const WhiteButton: React.FC<IProps> = ({
  forwardTestID,
  label,
  onPress,
  disabled,
  loading,
  styleButton,
}) => {
  return (
    <Container
      testID={forwardTestID}
      color={disabled ? Colors.disabledBackground : Colors.foodiBlack}
      style={styleButton}
      onPress={onPress}
      disabled={disabled}
    >
      {loading ? (
        <>
          <ActivityIndicator
            style={styles.loadingStyle}
            testID={TestIDs.components.Button.views.activityIndicator}
            color={Colors.foodiBlack}
          />
          <Label hide>{label}</Label>
        </>
      ) : (
        <Label
          testID={TestIDs.components.Button.texts.label}
          textColor={disabled ? Colors.disabledBackground : Colors.foodiBlack}
        >
          {label}
        </Label>
      )}
    </Container>
  );
};

const styles = StyleSheet.create({
  loadingStyle: {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    alignItems: "center",
    justifyContent: "center",
  },
});
